import moment from 'moment'

/**
 * format unix timestamp to YYYY-MM-DD HH:mm:ss
 * @param {number} timestamp unix timestamp (10 bits)
 */
export default {
  format (timestamp) {
    return moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
  },
  formatDay (timestamp) {
    return moment(timestamp).format('MM.DD')
  },
  formatDayTime (timestamp) {
    return moment(timestamp).format('YYYY.MM.DD')
  },
  formatTime (timestamp) {
    return moment(timestamp).valueOf()
  },
  formateSeconds (endTime) {
    let secondTime = parseInt(endTime / 1000) // 将传入的秒的值转化为Number
    let min = 0 // 初始化分
    let h = 0 // 初始化小时
    let result = ''
    if (secondTime > 60) { // 如果秒数大于60，将秒数转换成整数
      min = parseInt(secondTime / 60) // 获取分钟，除以60取整数，得到整数分钟
      secondTime = parseInt(secondTime % 60) // 获取秒数，秒数取佘，得到整数秒数
      if (min > 60) { // 如果分钟大于60，将分钟转换成小时
        h = parseInt(min / 60) // 获取小时，获取分钟除以60，得到整数小时
        min = parseInt(min % 60) // 获取小时后取佘的分，获取分钟除以60取佘的分
      }
    }
    result = `${h.toString().padStart(2, '0')} : ${min.toString().padStart(2, '0')} : ${secondTime.toString().padStart(2, '0')}`
    return result
  },
  taskStyle (val) { // 写作 录音
    let result = ''
    switch (val) {
      case 1:
        result = '写作'
        break
      case 2:
        result = '录音'
        break
      case 3:
        result = '视频制作'
        break
      case 4:
        result = '拍照'
        break
      case 5:
        result = '绘画'
        break
      case 6:
        result = '阅读'
        break
      case 7:
        result = '习题'
        break
      case 8:
        result = '批注'
        break
      case 9:
        result = '其他'
        break
    }
    return result
  },
  number2Text (textIndex) {
    let newString = ''
    const newTextIndex = (textIndex + 1) + ''

    function sum (value, index) {
      var newValue = ''
      if ((textIndex === 9)) {
        return !index ? '十' : ''
      }
      const isSeat = (~~textIndex > 9 && ~~textIndex < 19)
      switch (~~value) {
        case 1:
          newValue = !index ? (isSeat ? '' : '一') : '十一'
          break
        case 2:
          newValue = !index ? (isSeat ? '' : '二') : '十二'
          break
        case 3:
          newValue = !index ? (isSeat ? '' : '三') : '十三'
          break
        case 4:
          newValue = !index ? (isSeat ? '' : '四') : '十四'
          break
        case 5:
          newValue = !index ? (isSeat ? '' : '五') : '十五'
          break
        case 6:
          newValue = !index ? (isSeat ? '' : '六') : '十六'
          break
        case 7:
          newValue = !index ? (isSeat ? '' : '七') : '十七'
          break
        case 8:
          newValue = !index ? (isSeat ? '' : '八') : '十八'
          break
        case 9:
          newValue = !index ? (isSeat ? '' : '九') : '十九'
          break
        case 0:
          newValue = '十'
          break
        default:
          break
      }
      return newValue
    }

    for (let i = 0; i < newTextIndex.length; i++) {
      newString += sum(newTextIndex.substring(i, i + 1), i)
    }
    return newString
  },
  taskStyleText (val) {
    let result = ''
    switch (val) {
      case '写作':
        result = 1
        break
      case '录音':
        result = 2
        break
      case '视频':
        result = 3
        break
      case '拍照':
        result = 4
        break
      case '绘画':
        result = 5
        break
      case '阅读':
        result = 6
        break
      case '习题':
        result = 7
        break
    }
    return result
  },
  permission (val) {
    let result = ''
    switch (val) {
      case 1:
        result = '公开'
        break
      case 2:
        result = '私有'
        break
      case 3:
        result = '仅班级可见'
        break
      default:
        result = '公开'
    }
    return result
  },
  viewPermission (val) {
    let result = ''
    switch (val) {
      case 1:
        result = '公开'
        break
      case 2:
        result = '私有'
        break
      case 3:
        result = '仅班级可见'
        break
    }
    return result
  },
  mediaType (val) {
    let result = ''
    switch (val) {
      case 1:
        result = '纯文本'
        break
      case 2:
        result = '图文'
        break
      case 3:
        result = '视频'
        break
      case 4:
        result = '朗读音频'
        break
      case 5:
        result = '相关链接'
        break
      case 6:
        result = '教案（word，ppt）'
        break
      case 7:
        result = '通假字'
        break
      case 8:
        result = '词类活用'
        break
      case 9:
        result = '古今异义词'
        break
      case 10:
        result = '文化常识词'
        break
      case 11:
        result = '判断句'
        break
      case 12:
        result = '被动句'
        break
      case 13:
        result = '省略句'
        break
      case 14:
        result = '倒装句'
        break
    }
    return result
  },
  rangeType (val) {
    let result = ''
    switch (val) {
      case 1:
        result = '段落'
        break
      case 2:
        result = '句子'
        break
      case 3:
        result = '词汇'
        break
      case 4:
        result = '整篇'
        break
      case 5:
        result = '题目'
        break
    }
    return result
  },
  liveType (val) { // 名师之路
    let result = ''
    switch (val) {
      case 1:
        result = '课标'
        break
      case 2:
        result = '高考'
        break
      case 3:
        result = '教材'
        break
      case 4:
        result = '教学'
        break
    }
    return result
  },
  liveStatus (val) { // 名师之路
    let result = ''
    switch (val) {
      case 1:
        result = '正在直播'
        break
      case 2:
        result = '暂未开始'
        break
      case 3:
        result = '直播回放'
        break
    }
    return result
  },
  liveTypeText (val) {
    let result = ''
    switch (val) {
      case 1:
        result = '立即观看'
        break
      case 2:
        result = '暂未开始'
        break
      case 3:
        result = '查看回放'
        break
    }
    return result
  },
  articleType (val) {
    let result = ''
    switch (val) {
      case '':
        result = '全部'
        break
      case 1:
        result = '省级优质课'
        break
      case 2:
        result = '高考点拨'
        break
      case 3:
        result = '教学反思'
        break
      case 4:
        result = '教学设计'
        break
      case 5:
        result = '课程标准'
        break
      case 6:
        result = '师生风采'
        break
      case 7:
        result = '文本解读'
        break
      case 8:
        result = '写作指导'
        break
    }
    return result
  },
  showIcon (val) {
    let result = ''
    switch (val) {
      case 0:
        result = 'false'
        break
      case 1:
        result = 'true'
        break
    }
    return result
  },
  parseJson (val) {
    const result = JSON.parse(val)
    return result
  },
  textStatusType (val) {
    let result = ''
    switch (val) {
      case '':
        result = '全部'
        break
      case 3:
        result = '已发布'
        break
      case 1:
        result = '审核中'
        break
      case 2:
        result = '未通过'
        break
      case 0:
        result = '草稿箱'
        break
    }
    return result
  },
  textEditButton (val) {
    let result = ''
    switch (val) {
      case '':
        result = ''
        break
      case 0:
        result = '继续编辑'
        break
      case 1:
        result = ''
        break
      case 2:
        result = '重新编辑'
        break
      case 3:
        result = ''
        break
    }
    return result
  },
  isPublish (val) {
    let result = ''
    switch (val) {
      case 1:
        result = '已发布'
        break
      case 0:
        result = '未发布'
        break
    }
    return result
  },
  taskType (val) {
    let result = ''
    switch (val) {
      case 1:
        result = '班级任务'
        break
      case 2:
        result = '小组任务'
        break
    }
    return result
  },
  formatHour (timestamp) {
    return moment(timestamp).format('YYYY.MM.DD HH:mm')
  },
  formatReadType (val) {
    let result = ''
    switch (val) {
      case 1:
        result = '原文阅读'
        break
      case 2:
        result = '鉴赏阅读'
        break
      case 3:
        result = '互文比读'
        break
      default:
        result = '原文阅读'
        break
    }
    return result
  },
  classListString (val) {
    let str = ''
    for (let i = 0; i < val.length; i++) {
      str += val[i] + '、'
    }
    str = str.slice(0, str.length - 1)
    return str
  },
  // 去重某个数组含有的
  del_array_diff (a, b) {
    for (var i = 0; i < b.length; i++) {
      for (var j = 0; j < a.length; j++) {
        if (a[j] === b[i]) {
          a.splice(j, 1)
          j = j - 1
        }
      }
    }
    return a
  },
  formattedTime (milliseconds) {
    if (milliseconds === 0) {
      return '00:00:00'
    }
    const seconds = milliseconds / 1000
    let hours = Math.floor(seconds / 3600)
    let minutes = Math.floor((seconds - (hours * 3600)) / 60)
    let remainingSeconds = Math.floor(seconds - (hours * 3600) - (minutes * 60))

    hours = hours < 10 ? '0' + hours : hours
    minutes = minutes < 10 ? '0' + minutes : minutes
    remainingSeconds = remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds

    return hours + ':' + minutes + ':' + remainingSeconds
  }
}
